<template>
  <div class="page">
    <div class="container">
      <div class="page__row">
        <div class="heritage__animation">
          <div class="page__inner">
            <h1 class="title title_red page__title page__title_upper">Legacy</h1>
            <p class="lead page__lead">Every action we take today shapes the future, and at the same time, leaves a mark in history. We care about how our work impacts the world of our clients, and the world as a whole</p>
          </div>
          <div class="page__inner">
            <h1 class="title title_red page__title page__title_upper">Creativity</h1>
            <p class="lead page__lead">We use a non-linear approach, even if a task seems standard and straightforward</p>
          </div>
          <div class="page__inner">
            <h1 class="title title_red page__title page__title_upper">Collaboration</h1>
            <p class="lead page__lead">By integrating all areas of the communications industry, through people, knowledge, technologies, connections, brands, and ideas, we create quality for the client, for ourselves, and for the market as a whole</p>
          </div>
        </div>
      </div>
    </div>

    <missionSvg v-if="$isVisibleBg" />

    <page-footer :next="{ name: 'creation-en' }" />
  </div>
</template>

<script>
import { TimelineMax, TweenMax } from 'gsap'
import missionSvg from '@/components/missionSvg'
import PageFooter from '@/components/PageFooter'
import RouteMixin from '@/views/mixins/route'

export default {
  name: 'heritage-en',
  mixins: [RouteMixin],
  components: {
    missionSvg,
    PageFooter
  },
  mounted () {
    new TimelineMax()
      .add(TweenMax.from('.mission-bg', 0.5, { opacity: 0 }))
      .add(TweenMax.from('.page__title', 0.3, { y: '-30px', opacity: 0 }))
      .add(TweenMax.from('.page__lead', 0.3, { y: '-10px', opacity: 0 }))
  },
  beforeRouteLeave (to, from, next) {
    this.isDisabledRoute = true

    new TimelineMax()
      .add(TweenMax.to('.page__lead', 0.3, { y: '10px', opacity: 0 }))
      .add(TweenMax.to('.page__title', 0.3, { y: '30px', opacity: 0 }))
      .add(TweenMax.to('.mission-bg', 0.5, { opacity: 0 }))
      .eventCallback('onComplete', () => {
        next()
      })
  }
}
</script>
